import axios from './axios';

const API_URL = '/api/v1/dashboard';

export const getDashboard = async () => {
  return await axios.get(API_URL);
};
